import { alignCenter } from "helpers/styles/flex";
import { fullScreenSlide } from "helpers/styles/layout";
import styled from "styled-components";

export const Overlay = styled.div`
  ${fullScreenSlide};
  ${alignCenter};
  background-color: ${({ theme }) => theme.palette.primary.main};
`;
